export const getAllPaths = (menuItems, level = 1) => {
    const paths = [];
    
    if (level > 3 || !Array.isArray(menuItems)) return paths;
    
    menuItems.forEach(item => {
      
      if (item.path) {
        paths.push(item.path.toLowerCase().trim());
      }
      
      
      if (item.submenu && level < 3) {
        paths.push(...getAllPaths(item.submenu, level + 1));
      }
      
      
      if (item.subItems && level < 3) {
        paths.push(...getAllPaths(item.subItems, level + 1));
      }
      
      if (item.items && level < 3) {
        paths.push(...getAllPaths(item.items, level + 1));
      }
    });
    
    return paths;
  };